// Source: https://designnavigator.daimlertruck.com/Daimler_Truck_Colors?lang=en#color-codes
// Enhanced Daimler Truck color palette for optimal accessibility and branding
export const themeColors = {
  // Core brand colors
  black: '#000000',
  white: '#ffffff',
  yellow: '#ffff40',

  // Grey scale palette
  lightGrey: '#f5f5f5', // Backgrounds
  lightGrey20k: '#e0e0e0', // Subtle borders
  lightGrey40k: '#bdbdbd', // Disabled states
  lightGrey60k: '#757575', // Secondary text
  lightGrey80k: '#424242', // Primary text
  darkGrey: '#212121', // High contrast text

  // Petrol palette (primary brand color)
  petrol40k: '#004355', // Darkest - headers, navigation
  petrol20k: '#00566a', // Dark - selected states
  petrol: '#00677f', // Brand primary
  petrol80: '#007a93', // Hover states
  petrol60: '#5097ab', // Subtle accents
  petrol40: '#79aebf', // Light accents
  petrol20: '#a6cad8', // Very light backgrounds
  petrol10: '#d2e5eb', // Subtle highlights

  // Dark blue surfaces (dark theme)
  darkBlueBase: '#0b1623', // Main app background
  darkBlueSurface: '#102033', // Elevated surfaces
  darkBlueSurfaceAlt: '#132940', // Alternate elevated surfaces
  darkBlueBorder: '#1e3b5a', // Surface borders/dividers
  darkBlueMutedText: '#93acc4', // Secondary text on dark blue

  // Semantic colors
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
};

// Typography - Official Daimler CS font family as per design guidelines
export const daimlerFontFamily = {
  primary:
    '"Daimler CS", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fallback:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};
